// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"styles_listContainer__1C-OE","listTitle":"styles_listTitle__MkT5g"};